<template>
  <div style="width: 70vw; height: 70vh">
    <p class="md-title">Adicionar valor avulso</p>
    <md-steppers md-linear :md-active-step.sync="step">
      <md-step
        id="1"
        md-label="Escolher sensor"
        :md-done.sync="finishedFirst"
        style="padding-left: 0"
      >
        <Loading :loading.sync="loading" />
        <md-table
          v-model="sensores"
          md-sort="codigoIntegracao"
          md-sort-order="asc"
        >
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell
              md-label="Código integração"
              md-sort-by="codigoIntegracao"
            >
              {{ item.codigoIntegracao }}
            </md-table-cell>
            <md-table-cell md-label="Tipo" md-sort-by="tipoSensor">
              {{ item.tipoSensor }}
            </md-table-cell>
            <md-table-cell md-label="Descrição" md-sort-by="descricao">
              {{ item.descricao }}
            </md-table-cell>
            <md-table-cell>
              <md-button
                class="md-primary md-raised"
                @click="() => selectSensor(item)"
              >
                Selecionar
              </md-button>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </md-step>
      <md-step id="2" md-label="Enviar dado">
        <EquipamentoEnviarDadoAvulso
          v-if="finishedFirst"
          :sensor.sync="sensorSelected"
          :equipamento-id="equipamentoId"
          @change="change"
          @onCancel="backStepOne"
        />
      </md-step>
    </md-steppers>
  </div>
</template>

<script>
import http from '../../utils/http'
import Loading from '../Loading'
import EquipamentoEnviarDadoAvulso from './EquipamentoEnviarDadoAvulso'

export default {
  name: 'EquipamentoSelecionarSensor',
  components: { EquipamentoEnviarDadoAvulso, Loading },
  props: {
    equipamentoId: String,
  },
  data() {
    return {
      loading: true,
      step: '1',
      sensorSelected: null,
      sensores: [],
      finishedFirst: false,
    }
  },
  async mounted() {
    this.sensores = (
      await http.get(`equipamento/${this.equipamentoId}/sensores/detalhe`)
    ).sensores
    this.loading = false
  },
  methods: {
    change() {
      this.$emit('change')
    },
    selectSensor(sensor) {
      this.step = '2'
      this.sensorSelected = sensor
      this.finishedFirst = true
    },
    backStepOne() {
      this.step = '1'
      this.sensorSelected = null
      this.finishedFirst = false
    },
  },
}
</script>

<style scoped></style>
